import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader } from '../helpers';
import { postApi } from '../helpers/http';

export const requestPCSpecs = date => ({
  type: ActionTypes.REQUEST_PC_SPECS,
  date
})

export const receivePCSpecs = (params, json) => ({
  type: ActionTypes.RECEIVE_PC_SPECS,
  date: params.date,
  items: json.data,
  receivedAt: Date.now()
})

// export const  getTotalRowsPCSpecs = (json) => ({
//   type: ActionTypes.TOTALROWS_PC_SPECS,
//   totalRows: json.data
// })

// const doFetchDataCountPCSpecs = () => dispatch => {
//   const data = {
//           "process_type": "get_datacount",
//           "table_name": "pc_spec_tb",
//   };

//   return fetch(api.url, {
//       method: 'POST',
//       headers: authHeader(),
//       body: JSON.stringify(data),
//   }).then(response => response.json())
//   .then(json => {
//     // console.log('DataCount:', json.data);
//     dispatch(getTotalRowsPCSpecs(json))
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });
// // }

// export const fetchDataCountPCSpecs = params => (dispatch, getState) => {
//   return dispatch(doFetchDataCountPCSpecs(params))
// }

const doFetchPCSpecs = params => async dispatch => {
  dispatch(requestPCSpecs(params.date));

  const data = {
        "process_type": "getDataHpa27List",
        "mac_add": params.mac_add,
        "pc_name": params.pc_name,
        "user_id": params.user_id,
        "user_name": params.user_name,
        "version": params.version,
        "selected_version": params.selected_version,
        "offset": params.offset,
        "limit": params.limit,
  };
  // console.log('fetch:', data);
  try {
    const json = await postApi(data);
    dispatch(receivePCSpecs(params, json))
  } catch (error) {
    console.error('Error:', error);
  };
  
}

export const fetchPCSpecs = params => (dispatch, getState) => {
  return dispatch(doFetchPCSpecs(params));
}

export const requestManufacturers = date => ({
  type: ActionTypes.REQUEST_MANUFACTURER,
  date
})

export const receiveManufacturers = (params, json) => ({
  type: ActionTypes.RECEIVE_MANUFACTURER,
  date: params.date,
  items: json.data.manufacturer_list,
  receivedAt: Date.now()
})

const doFetchManufacturers = params => async dispatch => {
  dispatch(requestManufacturers(params))

  const data = {
        "process_type": "fncGetManufacturer",
  };

  try {
    const json = await postApi(data);
    dispatch(receiveManufacturers(params, json))
  } catch (error) {
    console.error('Error:', error);
  };

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json.data);
  //   dispatch(receiveManufacturers(params, json))
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchManufacturers = params => (dispatch, getState) => {
  return dispatch(doFetchManufacturers(params))
}

export const requestModels = date => ({
  type: ActionTypes.REQUEST_MODEL,
  date
})

export const receiveModels = (params, json) => ({
  type: ActionTypes.RECEIVE_MODEL,
  date: params.date,
  items: json.data.system_model_list,
  receivedAt: Date.now()
})

const doFetchModels = params => async dispatch => {
  dispatch(requestModels(params))

  const data = {
        "process_type": "fncGetSystemModel",
  };

  try {
    const json = await postApi(data);
    dispatch(receiveModels(params, json))
  } catch (error) {
    console.error('Error:', error);
  };

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json.data);
  //   dispatch(receiveModels(params, json))
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchModels = params => (dispatch, getState) => {
  return dispatch(doFetchModels(params))
}


